import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import useUnsubscribeService from '../../services/UnsubscribeService';

export interface UnsubscribePageState {
    isSuccessState: boolean;
    isLoading: boolean;
    email: string;
}

const initialState: UnsubscribePageState = {
    isSuccessState: false,
    isLoading: false,
    email: "",
}

export const UnsubscribePageSlice = createSlice({
    name: 'unsubscribePage',
    initialState,
    reducers: {
        setLoadingState: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setSuccessState: (state, action: PayloadAction<boolean>) => {
            state.isSuccessState = action.payload;
        },
        onEmailChanged: (state, action: PayloadAction<string>) => {
            state.email = action.payload;
        },
    }
});

export const unsubscribeAsync = createAsyncThunk<void, void, { state: RootState }>(
    'unsubscribePage/unsubscribeAsync',
    async (_, { dispatch, getState, rejectWithValue }) => {
        let appState = getState();
        const state = appState.unsubscribePage;

        dispatch(setLoadingState(true));
        var unsubscribeService = useUnsubscribeService();
        var unsubscribeSuccess = await unsubscribeService.unsubscribeUserAsync(state.email);

        if(unsubscribeSuccess === true)
        {
            dispatch(setSuccessState(true));
            return;
        }

        dispatch(setLoadingState(false));
        return;
    }
);

export const { setLoadingState, setSuccessState, onEmailChanged } = UnsubscribePageSlice.actions;

export const selectState = (state: RootState) => state.unsubscribePage;

export default UnsubscribePageSlice.reducer;